import classNames from 'classnames';
import React from 'react';
import { ArtistAttribution } from '../ArtistAttribution';
import './cityBrowseFooter.scss';
import { FooterImage } from './FooterImage';

interface CityBrowseFooterProps {
    footerImage?: string;
    footerSmallImage?: string;
    artistImage?: string;
    artistSummary?: string;
    artistName?: string;
    artistSocialLinks?: {
        type?: string;
        url?: string;
    }[];
    experiments?: any;
}

export class CityBrowseFooter extends React.PureComponent<CityBrowseFooterProps> {
    render() {
        const {
            footerImage,
            footerSmallImage,
            artistImage,
            artistSummary,
            artistName,
            artistSocialLinks,
            experiments,
        } = this.props;

        let bucketClasses = 'content-bucket';

        if (!footerImage && !footerSmallImage) {
            bucketClasses = classNames(
                'eds-l-mar-top-10',
                'eds-l-mw-pad-top-10',
                'eds-l-ln-pad-top-10',
                'eds-l-lg-pad-top-10',
                'eds-l-lw-pad-top-10',
            );
        }

        return (
            <footer className={bucketClasses}>
                <ArtistAttribution
                    image={artistImage}
                    summary={artistSummary}
                    name={artistName}
                    socialLinks={artistSocialLinks}
                    experiments={experiments}
                />
                <FooterImage
                    footerImage={footerImage}
                    footerSmallImage={footerSmallImage}
                    experiments={experiments}
                />
            </footer>
        );
    }
}
